import { memo } from "react";
import z from "zod";
import { withForm } from "../../../hooks/useForm";
import { TableRow, TableCell } from "../../ui/table";
import { EmpresaDatosAnio } from "@/@types/Api_Extracted";

interface InputRowProps {
	isNew: boolean;
}
const InputRow = withForm({
	defaultValues: {} as EmpresaDatosAnio,
	props: {} as InputRowProps,
	render: function Render({ form, isNew }) {
		return (
			<TableRow>
				{!isNew || (
					<TableCell>
						<form.AppField
							name={`anio`}
							validators={{
								onChange: z.number().max(new Date().getFullYear(), {
									message: `No puedes crear datos del futuro`,
								}),
							}}
							children={(field) => <field.NumberField label={""} />}
						/>
					</TableCell>
				)}
				<TableCell>
					<form.AppField
						name={`cantidadTrabajadores`}
						validators={{ onChange: z.number() }}
						children={(field) => <field.NumberField label={""} />}
					/>
				</TableCell>
				<TableCell>
					<form.AppField
						name={`materiaPrima`}
						validators={{ onChange: z.number() }}
						children={(field) => <field.NumberField label={"kg"} />}
					/>
				</TableCell>
				<TableCell>
					<form.AppField
						name={`desechos`}
						validators={{ onChange: z.number() }}
						children={(field) => <field.NumberField label={"kg"} />}
					/>
				</TableCell>
				<TableCell>
					<form.AppField
						name={`facturacion`}
						validators={{ onChange: z.number() }}
						children={(field) => <field.NumberField label={"€"} />}
					/>
				</TableCell>
			</TableRow>
		);
	},
});
export const DatosAnioInputRowMemo = memo(InputRow);
